export default __webpack_public_path__ + "static/image-2-mob-89f2b525dc179e71935dd0dbb5611bb6.jpg";